import { useState, useEffect } from "react";
import { Phone, Globe, TrendingUp, Users, Zap, CheckCircle } from "lucide-react";

const activities = [
  { icon: Phone, text: "New agent created for TechCorp" },
  { icon: Globe, text: "Agent handling call in German" },
  { icon: CheckCircle, text: "Lead qualified - Real Estate Pro" },
  { icon: Users, text: "3 appointments booked today" },
  { icon: TrendingUp, text: "98.7% satisfaction rate" },
  { icon: Zap, text: "Agent deployed in 45 seconds" },
  { icon: Phone, text: "Support call completed - 4.2min" },
  { icon: Globe, text: "New Spanish-speaking agent live" },
  { icon: CheckCircle, text: "Sales call converted - $2,400" },
  { icon: Users, text: "Healthcare agent handling inquiry" },
];

const LiveActivityTicker = () => {
  const [counter, setCounter] = useState({ calls: 128470, agents: 342, satisfaction: 98.7 });

  useEffect(() => {
    const interval = setInterval(() => {
      setCounter(prev => ({
        calls: prev.calls + Math.floor(Math.random() * 3),
        agents: prev.agents + (Math.random() > 0.7 ? 1 : 0),
        satisfaction: Math.min(99.9, prev.satisfaction + (Math.random() - 0.5) * 0.1)
      }));
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="w-full bg-card/50 backdrop-blur-sm border-y border-border overflow-hidden">
      <div className="container mx-auto px-4 py-2">
        <div className="flex items-center gap-6 overflow-hidden">
          {/* Live Indicator */}
          <div className="flex items-center gap-2 flex-shrink-0">
            <span className="relative flex h-2 w-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-green-500"></span>
            </span>
            <span className="text-xs font-semibold text-green-500 uppercase tracking-wider">Live</span>
          </div>

          {/* Stats */}
          <div className="hidden md:flex items-center gap-6 flex-shrink-0 border-r border-border pr-6">
            <div className="text-center">
              <div className="text-sm font-bold text-primary tabular-nums">{counter.calls.toLocaleString()}</div>
              <div className="text-[10px] text-muted-foreground uppercase">Calls Today</div>
            </div>
            <div className="text-center">
              <div className="text-sm font-bold text-primary tabular-nums">{counter.agents}</div>
              <div className="text-[10px] text-muted-foreground uppercase">Active Agents</div>
            </div>
            <div className="text-center">
              <div className="text-sm font-bold text-green-500 tabular-nums">{counter.satisfaction.toFixed(1)}%</div>
              <div className="text-[10px] text-muted-foreground uppercase">Satisfaction</div>
            </div>
          </div>

          {/* Smooth Scrolling Activities */}
          <div className="flex-1 overflow-hidden relative">
            <div className="ticker-track">
              <div className="ticker-content">
                {activities.map((activity, index) => {
                  const Icon = activity.icon;
                  return (
                    <div key={index} className="ticker-item">
                      <Icon className="w-3 h-3 text-primary/70" />
                      <span>{activity.text}</span>
                    </div>
                  );
                })}
              </div>
              <div className="ticker-content" aria-hidden="true">
                {activities.map((activity, index) => {
                  const Icon = activity.icon;
                  return (
                    <div key={`dup-${index}`} className="ticker-item">
                      <Icon className="w-3 h-3 text-primary/70" />
                      <span>{activity.text}</span>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>

          {/* Trending indicator */}
          <div className="hidden lg:flex items-center gap-1 flex-shrink-0 text-green-500">
            <TrendingUp className="w-3 h-3" />
            <span className="text-xs font-medium">+23% today</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LiveActivityTicker;